import { useQuery } from 'react-query';
import { getListingPhotos } from '../../../services/listing';
import { ListingPhoto } from '../../../types/db/listings';

export interface IListingPicturesContainerProps {
    listingId: string | string[];
    children?: (data: State) => JSX.Element;
}

interface State {
    loading: boolean;
    images: ListingPhoto[];
    totImages: number;
}

export const ListingPhotosContainer = ({ listingId, children }: IListingPicturesContainerProps) => {
    const { isLoading, data } = useQuery(
        ['ListingPhotos', (Array.isArray(listingId) ? listingId.join('/') : listingId)],
        () => getListingPhotos(listingId)
    );

    return !!children ?
        children({ loading: isLoading, images: data || [], totImages: data?.length ?? 0 })
        :
        null
        ;
}